import httpClient from '../httpClient';

const uploadCertificate = (certificates, disciplines, documentMetadata = {}, profileData = {}) => {
  const formData = new FormData();

  if (Array.isArray(certificates)) {
    certificates.forEach(file => {
      formData.append('files', file, file.name);
    });
  } else if (certificates) {
    formData.append('files', certificates, certificates.name);
  }

  if (Array.isArray(disciplines)) {
    disciplines.forEach(d => {
      formData.append('discipline', d);
    });
  } else if (disciplines) {
    formData.append('discipline', disciplines);
  }

  // Send document metadata fields individually
  if (documentMetadata) {
    // Required fields
    if (documentMetadata.documentType) {
      formData.append('documentType', documentMetadata.documentType);
    }
    
    // Optional fields
    if (documentMetadata.country) {
      formData.append('country', documentMetadata.country);
    }
    if (documentMetadata.issuer) {
      formData.append('issuer', documentMetadata.issuer);
    }
    if (documentMetadata.registerId) {
      formData.append('registerId', documentMetadata.registerId);
    }
    if (documentMetadata.issuerUrl) {
      formData.append('issuerUrl', documentMetadata.issuerUrl);
    }
    if (documentMetadata.expiryDate) {
      formData.append('expiryDate', documentMetadata.expiryDate);
    }
    
    // Arrays need to be sent as JSON strings or multiple fields
    if (documentMetadata.activities && Array.isArray(documentMetadata.activities)) {
      documentMetadata.activities.forEach(a => {
        formData.append('activities', a);
      });
    }
    if (documentMetadata.disciplines && Array.isArray(documentMetadata.disciplines)) {
      documentMetadata.disciplines.forEach(d => {
        formData.append('disciplines', d);
      });
    }
    
    // Other metadata
    if (documentMetadata.reviewStatus) {
      formData.append('reviewStatus', documentMetadata.reviewStatus);
    }
    if (documentMetadata.fileName) {
      formData.append('fileName', documentMetadata.fileName);
    }
    if (documentMetadata.uploadedAt) {
      formData.append('uploadedAt', documentMetadata.uploadedAt);
    }
    if (documentMetadata.operatorNotes !== undefined) {
      formData.append('operatorNotes', documentMetadata.operatorNotes === null ? '' : documentMetadata.operatorNotes);
    }
    // Editing index for file replacement
    if (documentMetadata.editingIndex !== undefined && documentMetadata.editingIndex !== null) {
      formData.append('editingIndex', documentMetadata.editingIndex);
    }
  }
  
  // Send profile data (activities, selfCertifications) to backend
  // Backend will handle updating Sharetribe with all data at once
  if (profileData && Object.keys(profileData).length > 0) {
    formData.append('profileData', JSON.stringify(profileData));
  }

  return httpClient.post('users/files', formData);
};

const deleteCertificate = discipline => {
  return httpClient.delete('users/files', {
    data: {
      discipline,
    },
  });
};

/**
 * Our BE returns  { availabilityException } for success
 * or 409 if there is a conflict error with existing exception
 */
const addAvailabilityException = (startsAt, endsAt) => {
  return httpClient.post('users/availability-exceptions', { startsAt, endsAt });
};

const deleteAvailabilityException = exceptionId => {
  return httpClient.delete(`users/availability-exceptions/${exceptionId}`);
};

const getAvailabilityExceptions = params => {
  return httpClient.get('users/availability-exceptions', { params });
};

const addPromoCodes = codes => {
  return httpClient.post('users/promo-codes', { codes });
};

const verifyInstagram = accessToken => {
  return httpClient.post('users/verify-instagram', { accessToken });
};

const partnerApproval = partnerKey => {
  return httpClient.post('users/partner-approval', { partnerKey });
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  uploadCertificate,
  deleteCertificate,
  addAvailabilityException,
  deleteAvailabilityException,
  getAvailabilityExceptions,
  addPromoCodes,
  verifyInstagram,
  partnerApproval,
};
